/// <reference types="user-agent-data-types" />

export type OS =
  | "mac os"
  | "ios"
  | "windows"
  | "android"
  | "linux"
  | "not identified";

// USE ONLY INSIDE CLIENT CODE
export function getOS(): OS | null {
  if (typeof window === "undefined") return null; // server-side fallback

  const userAgent = window.navigator.userAgent,
    platform =
      window.navigator?.userAgentData?.platform || window.navigator.platform,
    macosPlatforms = ["macOS", "Macintosh", "MacIntel", "MacPPC", "Mac68K"],
    windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"],
    iosPlatforms = ["iPhone", "iPad", "iPod"];
  let os = null;

  if (macosPlatforms.indexOf(platform) !== -1) {
    os = "mac os";
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = "ios";
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = "windows";
  } else if (/Android/.test(userAgent)) {
    os = "android";
  } else if (/Linux/.test(platform)) {
    os = "linux";
  } else {
    os = "not identified";
  }

  return os.toLowerCase() as OS;
}
